import axios from 'axios';

export default {
  getRegions() {
    return axios.get('region');
  },
};
